import { render } from "./workflowActivity.vue?vue&type=template&id=7ce88b8a&scoped=true"
import script from "./workflowActivity.vue?vue&type=script&lang=js"
export * from "./workflowActivity.vue?vue&type=script&lang=js"

import "./workflowActivity.vue?vue&type=style&index=0&id=7ce88b8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce88b8a"]])

export default __exports__